<template>
  <SACModal
    modalClass="service-action-modal"
    :cardClass="`serv-${actionModalView}`"
    :show="showActionModal "
    :close="() => toggleActionModal(false)"
  >
    <template
      v-if="actionTechnicianModalView === 'invite-tech' && showTechnicianActionModal"
      #content
    >
      <InviteTechnician />
    </template>
    <template
      v-else-if="actionModalView === 'snooze-lead'"
      #content
    >
      <Snooze />
    </template>
    <template
      v-else-if="actionModalView === 'delete-confirm'"
      #content
    >
      <DeleteNote />
    </template>
    <template
      v-else-if="actionModalView === 'schedule-request'"
      #content
    >
      <ServiceRequestForm />
    </template>
    <template
      v-else-if="actionModalView === 'cancel-request'"
      #content
    >
      <Decline
        header="Cancel"
        title="Why are you cancelling this job?"
      />
    </template>
    <template
      v-else-if="actionModalView === 'decline-request'"
      #content
    >
      <Decline
        header="Cancel"
        title="Why are you declining this job?"
      />
    </template>
    <template
      v-else-if="actionModalView === 'dismiss-lead'"
      #content
    >
      <DismissLead />
    </template>
    <template
      v-else-if="actionModalView === 'dismiss-alert'"
      #content
    >
      <DismissLead
        isAlert
      />
    </template>
    <template
      v-else-if="actionModalView === 'set-chronic'"
      #content
    >
      <SetChronicAlert />
    </template>
    <template
      v-else-if="actionModalView === 'view-note'"
      #content
    >
      <ViewNote />
    </template>
    <template
      v-else-if="actionModalView === 'add-note'"
      #content
    >
      <AddNote />
    </template>
    <template
      v-else-if="actionModalView === 'edit-note'"
      #content
    >
      <AddNote isEdit />
    </template>
    <template
      v-else-if="actionModalView === 'view-all-notes'"
      #content
    >
      <ViewAllNotes />
    </template>
    <template
      v-else-if="actionModalView === 'complete-request'"
      #content
    >
      <ServiceResolved
        isComplete
      />
    </template>
    <template
      v-else-if="actionModalView === 'resolve'"
      #content
    >
      <ServiceResolved />
    </template>
    <template
      v-else-if="actionModalView === 'new-service'"
      #content
    >
      <NewServiceRequest />
    </template>
    <template
      v-else-if="actionModalView === 'invoice'"
      #content
    >
      <AddInvoice />
    </template>
  </SACModal>
</template>

<script>
import { mapState } from 'vuex';

import serviceMixin from '@shared/mixins/serviceMixin';
import SACModal from '@shared/components/sac/SACModal.vue';
import DeleteNote from '@shared/components/service/modal/DeleteNote.vue';
import DismissLead from '@shared/components/service/modal/DismissLead.vue';
import SetChronicAlert from '@shared/components/service/modal/SetChronicAlert.vue';
import Snooze from './modal/Snooze.vue';
import ViewNote from './modal/ViewNote.vue';
import AddNote from './modal/AddNote.vue';
import ServiceResolved from './modal/ServiceResolved.vue';
import NewServiceRequest from './modal/NewServiceRequest.vue';
import Decline from './modal/Decline.vue';
import ServiceRequestForm from './modal/ServiceRequestForm.vue';
import ViewAllNotes from './modal/ViewAllNotes.vue';
import InviteTechnician from '../technician/modal/InviteTechnician.vue';
import AddInvoice from './modal/AddInvoice.vue';

export default {
  name: 'ActionModal',
  components: {
    SetChronicAlert,
    DismissLead,
    DeleteNote,
    ServiceRequestForm,
    NewServiceRequest,
    SACModal,
    Snooze,
    ViewNote,
    AddNote,
    ServiceResolved,
    Decline,
    ViewAllNotes,
    InviteTechnician,
    AddInvoice,
  },
  mixins: [serviceMixin],
  computed: {
    ...mapState(({
      actionTechnicianModalView: (state) => state.technician.actionModalView,
      showTechnicianActionModal: (state) => state.technician.showActionModal,
    })),
  },
};
</script>
<style lang="scss">
.service-action-modal {
  .serv-schedule-request, .serv-new-service, .serv-complete-request, .serv-invoice {
    width: 600px;
    height: 770px;
    max-height: calc(100vh - 70px);
  }
  .serv-publish-confirmation {
    width: 600px;
    height: 450px;
  }
  .serv-snooze-lead {
    width: 600px;
    height: 603px;
  }
  .serv-service {
    width: 600px;
    height: 560px;
  }
  .serv-view-note{
    width: 500px;
  }
  .serv-delete-confirm{
    width: 500px;
  }
  .serv-add-note, .serv-edit-note {
    width: 600px;
    height: 500px;
  }
  .serv-view-all-notes {
    width: 464px;
    height: 600px;
    max-height: calc(100vh - 70px);
  }
  .serv-resolve, .serv-complete-request {
    width: 600px;
    height: 600px;
  }
  .serv-totals {
    width: 600px;
    height: 550px;
  }
  .serv-coming {
    width: 600px;
    height: 525px;
  }
  .serv-invalid {
    width: 450px;
    height: 260px;
  }
  .serv-dismiss-lead, .serv-dismiss-alert, .serv-cancel-request {
    width: 600px;
    height: 558px;
  }
  .serv-decline-request, .serv-set-chronic {
    width: 600px;
    height: 558px;
  }
  .serv-new-service {
    width: 600px;
    height: 770px;
    max-height: calc(100vh - 70px);
  }
  .ac-header-note {
    padding: 29px 24px 19px 24px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid $NBLUE10;
    .ac-header {
      font-size: 1.25rem;
      font-weight: 500;
    }
    .ac-close-button {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background-color: $NBLUE10;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: $NBLUE20;
      }
      .ac-close {
        width: 10px;
        height: 10px;
      }
    }
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $NBLUE10;
      gap: 20px;
      .ac-header {
        font-size: 1.50rem;
        font-weight: 600;
      }
      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: $NBLUE20;
        }
        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }
    .ac-body-container {
      flex: 1;
      padding: 1rem;
      overflow-y: auto;
      .ac-input-container {
        &:not(:last-child) {
          margin-bottom: 16px;
        }
        .ac-input-header {
          font-size: 1.25rem;
          font-weight: 500;
          margin-bottom: 11px;
          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }
        }
        .ac-input-number {
          height: 48px;
          border-radius: 33px;
          width: 80px;
          padding: 0 20px;
          background-color: $NBLUE20;
        }
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input {
          height: 48px;
          width: 100%;
          background-color: $NBLUE5;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }
        .match-background {
          background: $NBLUE5;
          border-radius: 3px;
          border: unset;
          height: 48px;
        }
        textarea {
          width: 100%;
          height: 143px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
          border: none;
          resize: none;
        }
        .ac-input-footer-container {
          display: flex;
          .ac-text-count {
            flex: 1;
            text-align: right;
            font-size: 0.75rem;
            font-weight: 500;
            color: $N60;
          }
        }
        .ac-input-error {
          color: $TOMATO100;
          font-size: 0.875rem;
        }
      }
      .ac-status {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: $NBLUE5;
        padding: 20px;
        border-radius: 6px;
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: 500;
      }
      .ac-note-container {
        margin-bottom: 10px;
        .ac-note {
          font-weight: 500;
        }
        .ac-action-note {
          font-weight: 200;
        }
        .ac-info {
          font-weight: 500;
        }
      }
      .ac-p-text {
        display: grid;
        justify-content: center;
      }
    }
    .ac-body-header {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
    }
    .ac-body-button-container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      .ac-form-button {
        width: 120px;
        height: 40px;
        border-radius: 6px;
        background-color: $NBLUE10;
        font-weight: 600;
        &:hover {
          background-color: $NBLUE20;
        }
        &:not(:first-child) {
          margin-left: 11px;
          background-color: $NBLUE100;
          color: $WHITE;
          &:hover {
            background-color: $NBLUE90;
          }
        }
      }
    }
  }
  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 1rem;
    border-top: 1px solid $NBLUE10;
    .ac-back-container {
      flex: 1;
      justify-content: flex-start;
      .ac-back-button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;
        width: 177px;
        height: 40px;
        border-radius: 6px;
        background-color: $NBLUE10;
        &:hover {
          background-color: $NBLUE20;
        }
        .back-icon {
          width: 6px;
        }
        .button-text {
          font-weight: 600;
        }
      }
    }
    .ac-form-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE10;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE20;
      }
      &:not(:first-child) {
        margin-left: 11px;
        background-color: $NBLUE100;
        color: $WHITE;
        &:hover {
          background-color: $NBLUE90;
        }
      }
      .ac-processing {
        width: 30px;
      }
    }
  }

  .ac-footer-start-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1rem;
    border-top: 1px solid $NBLUE10;
    gap: 15px;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
